var React = require('react');
//let NewRequestCreateCardActions = require('../actions/NewRequestCreateCardActions');

var RadioButtonDistributionCodeColumn = React.createClass({

    changeRadio: function (id) {
        //NewRequestCreateCardActions.getRadio(id);
        this.props.getRadio(id);
    },

    render: function () {

        return (
            <div className="col-md-2">
                <div className="container-radio radio-margin">
                    <input type="radio" id={"rbDistribucion" + this.props.Id}  checked={this.props.checked} name="group" onClick={() => this.changeRadio(this.props.Id)}></input>
                    <label className="lbl-radio label-secondary" htmlFor={"rbDistribucion" + this.props.Id} onClick={() => this.changeRadio(this.props.Id)}>{this.props.CodigoDistribucion}</label>                    
                </div>
            </div>
        );
    }
});

export default RadioButtonDistributionCodeColumn